// import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
// import "./css/BillerApp.css";
// import 'bootstrap/dist/css/bootstrap.css';
// import Editing1 from './images/MenuReg/Editing1.png';
// import Redeye1 from './images/Inventory/visible.png';
// import remove from './images/Inventory/delete.png';
// import right from './images/right-arrow.png';
// import SideNav from './SideNav';
// import TopRootDiv from './TopRootDiv';
// import SherDineNav from './SherDineNav';
// import { useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import axios from 'axios';
// import io from 'socket.io-client';
// import { DBContext } from './DBContext';
// import Qsearch from "./images/Qsearch.png";

// function BillReport() {
//     const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
//     const { logginedDB } = useContext(DBContext);
//     const navigate = useNavigate();

//     // Date filter state
//     const [dates, setDates] = useState({ sdate: "", edate: "" });

//     // Pagination state
//     const [salesData, setSalesData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [hasMore, setHasMore] = useState(true);
//     const [offset, setOffset] = useState(0);
//     const [initialLoadComplete, setInitialLoadComplete] = useState(false);
//     const limit = 50; // Number of items to load per batch

//     // User management states (keep your existing states)
//     const [userTypes, setUserTypes] = useState([]);
//     const [uType, setUType] = useState(null);
//     const [userList, setUserList] = useState([]);
//     const [isActive, setIsActive] = useState({});
//     const [selectedUsers, setSelectedUsers] = useState([]);
//     const [checkedItems, setCheckedItems] = useState([]);
//     const [isCheckedAll, setIsCheckedAll] = useState(false);
//     const [sideNav, setSideNav] = useState(false);
//     const [falseState, setFalseState] = useState(null);
//     const [viewUserDetails, setViewUserDetails] = useState(null);
//     const [isExiting, setIsExiting] = useState(false);
//     const [showONebill, setShowOnebill] = useState(false)
//     const [oneBill, setOneBill] = useState(null);

//     const handleSideNav = (state) => {
//         setSideNav(state)
//     }
//     // Load more data function
//     const loadMoreData = useCallback(async (reset = false, selectedUserType = null) => {

//         // const loadMoreData = useCallback(async (loadAll = false) => {
//         // if (loading || (!loadAll && !hasMore)) return;
//         if (loading) return;
//         setLoading(true);
//         try {
//             const currentOffset = reset ? 0 : offset;
//             const response = await axios.get(
//                 `${apiBaseUrl}/getSalesDetailsAlls/${logginedDB}`,
//                 {
//                     // params: {
//                     //     limit: loadAll ? undefined : limit,
//                     //     offset: loadAll ? undefined : offset,
//                     //     todayOnly: !dates.sdate && !dates.edate, // Load today's data if no date filter
//                     //     all: loadAll
//                     // }
//                     // params: { limit, offset, todayOnly: true }
//                     params: {
//                         limit: reset ? undefined : limit,
//                         offset: reset ? 0 : offset,
//                         todayOnly: !dates.sdate && !dates.edate,
//                         userType: selectedUserType || uType?.userType, // Pass selected user type
//                         // all: loadAll
//                     }
//                 }
//             );

//             if (response.status === 200) {
//                 const newData = response.data.data || [];

//                 // setSalesData(prev =>
//                 //     reset ? newData : [...prev, ...newData]
//                 // );

//                 setSalesData(newData)

//                 setHasMore(newData.length === limit);
//                 setOffset(currentOffset + newData.length);

//                 if (reset) {
//                     setInitialLoadComplete(true);
//                 }
//                 //     if (loadAll) {
//                 //         console.log("response", response);

//                 //         setSalesData(newData);
//                 //         setHasMore(false);
//                 //     } else {
//                 //         setSalesData(prev => [...prev, ...newData]);
//                 //         // setHasMore(response.data.hasMore);
//                 //         setHasMore(newData.length === limit)
//                 //         setOffset(prev => prev + limit);
//                 //     }

//                 //     if (!initialLoadComplete) setInitialLoadComplete(true);
//                 //     if (newData.length === 0 && salesData.length === 0) {
//                 //         // toast.info("No sales records found for the selected criteria");
//                 //     }
//             }
//         } catch (error) {
//             console.error("Error loading sales data:", error);
//             toast.error("Failed to load sales data");
//         } finally {
//             setLoading(false);
//         }
//     }, [loading, offset, limit, logginedDB, dates]);

//     // }, [loading, hasMore, offset, limit, logginedDB, initialLoadComplete, dates]);
//     // Initial load and reset handler
//     useEffect(() => {
//         if (logginedDB) {
//             loadMoreData(true); // Reset and load fresh data
//         }
//     }, [logginedDB]);
//     // Initial load
//     useEffect(() => {
//         if (logginedDB && !initialLoadComplete) {
//             loadMoreData();
//         }
//     }, [logginedDB, initialLoadComplete, loadMoreData]);
//     const handleList = async (type) => {
//         setUType(type);
//         loadMoreData(true, type.userType); // Reset and load data for selected user type
//         setCheckedItems(userList.map(() => false));
//         setIsCheckedAll(false);
//     };
//     // Infinite scroll handler
//     useEffect(() => {
//         const handleScroll = () => {
//             if (
//                 window.innerHeight + document.documentElement.scrollTop <
//                 document.documentElement.offsetHeight - 100 ||
//                 loading ||
//                 !hasMore
//             ) {
//                 return;
//             }
//             loadMoreData();
//         };

//         window.addEventListener('scroll', handleScroll);
//         return () => window.removeEventListener('scroll', handleScroll);
//     }, [loading, hasMore, loadMoreData]);

//     // Handle date range search
//     const handleSearch = async () => {
//         if (dates.sdate && dates.edate && dates.sdate > dates.edate) {
//             toast.error("End date must be after start date");
//             return;
//         }

//         setLoading(true);
//         try {
//             const endpoint = dates.sdate || dates.edate
//                 ? `${apiBaseUrl}/getSalesDetails/${logginedDB}/${new Date().toISOString().split('T')[0]}`
//                 : `${apiBaseUrl}/getSalesDetailsAlls/${logginedDB}`;

//             const response = await axios.get(endpoint, {
//                 params: {
//                     sdate: dates.sdate,
//                     edate: dates.edate,
//                     limit: dates.sdate || dates.edate ? undefined : limit,
//                     todayOnly: !dates.sdate && !dates.edate
//                 }
//             });

//             if (response.status === 200) {
//                 setSalesData(response.data.recordset || response.data.data || response.data);
//                 setHasMore(!(dates.sdate || dates.edate)); // Disable infinite scroll for filtered results
//                 setOffset(0);
//             }
//         } catch (error) {
//             console.error("Error fetching sales data:", error);
//             toast.error("Failed to fetch sales data");
//         } finally {
//             setLoading(false);
//         }
//     };


//     // Reset to today's data
//     const handleReset = () => {
//         setDates({ sdate: "", edate: "" });
//         setSalesData([]);
//         setOffset(0);
//         setHasMore(true);
//         setInitialLoadComplete(false);
//     };

//     // Format currency
//     const formatCurrency = (amount) => {
//         return parseFloat(amount || 0).toFixed(2);
//     };

//     // Format date
//     const formatDate = (dateString) => {
//         const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
//         return new Date(dateString).toLocaleDateString(undefined, options);
//     };

//     // Calculate totals
//     useEffect(() => {
//         if (salesData.length > 0) {
//             const totals = salesData.reduce((acc, curr) => {
//                 acc.total += parseFloat(curr.TotalAmount || 0);
//                 acc.discount += parseFloat(curr.Discount || 0);
//                 acc.netAmount += parseFloat(curr.NetAmount || 0);
//                 return acc;
//             }, { total: 0, discount: 0, netAmount: 0 });

//             // You can use these totals in your UI
//             console.log('Totals:', totals);
//         }
//     }, [salesData]);

//     // Your existing user management functions
//     const handleGetUserTypes = async () => {
//         try {
//             const response = await axios.get(`${apiBaseUrl}/getUserTypes/${logginedDB}`);
//             if (response.status === 200) {
//                 setUserTypes(response.data);
//             }
//         } catch (error) {
//             console.error("Error fetching user types:", error);
//         }
//     };

//     // Initialize component


//     const socketRef = useRef(null);

//     // useEffect(() => {
//     //   if (!logginedDB) return; // if not logged in, skip

//     //   // connect socket
//     //   socketRef.current = io(apiBaseUrl, {
//     //     transports: ["websocket"], // faster than polling
//     //   });

//     //   // make sure old listeners are removed before adding new ones
//     //   socketRef.current
//     //     .off("updateUser")
//     //     .on("updateUser", handleGetUserTypes());

//     //   // cleanup on unmount
//     //   return () => {
//     //     socketRef.current.disconnect();
//     //   };
//     // }, [apiBaseUrl, logginedDB]);


//     useEffect(() => {
//         if (!logginedDB) return;
//         handleGetUserTypes();

//         socketRef.current = io(apiBaseUrl, {
//             transports: ["websocket"],
//         });

//         // Event listeners
//         const geteHandlerUserTypes = () => handleGetUserTypes();


//         socketRef.current.on("connect", () => {
//             console.log("Connected to server");
//         });

//         socketRef.current.on("disconnect", () => {
//             console.log("Disconnected from server");
//         });

//         socketRef.current.on("connect_error", (error) => {
//             console.error("Connection error:", error);
//         });


//         socketRef.current.on("updateUser", geteHandlerUserTypes);


//         return () => {
//             if (socketRef.current) {
//                 socketRef.current.off("updateUser", geteHandlerUserTypes);
//                 socketRef.current.disconnect();
//             }
//         };
//     }, [apiBaseUrl, logginedDB]);


//     const handleLoadAll = async () => {
//         setLoading(true);
//         try {
//             const response = await axios.get(
//                 `${apiBaseUrl}/getSalesDetailsAlls/${logginedDB}`,
//                 {
//                     params: {
//                         all: true
//                     }
//                 }
//             );

//             if (response.status === 200) {
//                 setSalesData(response.data.data);
//                 setHasMore(false); // No more data to load
//             }
//         } catch (error) {
//             console.error(error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleShowBill = (data) => {
//         setOneBill(data);
//         setShowOnebill(true)
//     }

//     return (
//         <div className='TableRegMainDiv'>
//             <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
//             <ToastContainer position="top-right" autoClose={3000} />

//             <div className='w-full bg-[#f5f5f5] flex gap-3 h-full overflow-hidden'>
//                 <div className='w-max h-full z-[9999]'>
//                     <SideNav focus={'Report'} state={sideNav} falseState={(state) => setFalseState(state)} />
//                 </div>

//                 <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden'>
//                     <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
//                         <TopRootDiv image={'Menu Management'} root={['Root']} />
//                     </div>

//                     <div className='w-full h-full flex flex-col gap-3 relative overflow-hidden'>
//                         {/* Date filter controls */}
//                         <div className='w-full flex h-max rounded-t bg-[#fff] p-3 items-center'>
//                             <div className='w-10/12 flex overflow-auto'>
//                                 {userTypes.map((type, index) => (
//                                     <div
//                                         key={index}
//                                         className={`font-nunito text-[1rem] font-[600] pt-3 pb-3 pl-5 pr-5 cursor-pointer ${uType?.userType === type.userType ? 'MenuCategoryActive' : 'MenuCategoryNotActive'
//                                             }`}
//                                         // onClick={() => setUType(type)}
//                                         onClick={() => handleList(type)}

//                                     >
//                                         {type.userType}
//                                     </div>
//                                 ))}
//                             </div>

//                             <div className='w-2/12 flex font-nunito font-[600] justify-end items-center gap-2 pr-3 text-[.9rem]'>
//                                 <div className='flex gap-2 items-center'>
//                                     <input
//                                         type="date"
//                                         value={dates.sdate}
//                                         onChange={(e) => setDates({ ...dates, sdate: e.target.value })}
//                                         className="border rounded p-1 text-sm"
//                                     />
//                                     <span>to</span>
//                                     <input
//                                         type="date"
//                                         value={dates.edate}
//                                         onChange={(e) => setDates({ ...dates, edate: e.target.value })}
//                                         className="border rounded p-1 text-sm"
//                                     />
//                                     <button
//                                         onClick={handleSearch}
//                                         className="flex items-center bg-[#fff] justify-center min-w-[2.5rem] min-h-[2.5rem] text-[#0008B4] rounded-[.313rem]"
//                                     >
//                                         <img src={Qsearch} alt="Search" className="w-6 h-6 object-contain" />
//                                     </button>
//                                     <button
//                                         // onClick={handleReset}
//                                         onClick={handleLoadAll}
//                                         className="bg-gray-200 text-gray-800 px-3 py-1 rounded text-sm"
//                                     >
//                                         All
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Sales data table */}
//                         <div className='w-full h-full font-nunito flex flex-col bg-[#fff] overflow-hidden rounded-b'>
//                             <div className='w-full text-center font-[600] flex bg-[#e0e0e0] sticky top-0 z-10'>
//                                 <div className='w-[8%] p-3 text-left'>Bill No</div>
//                                 <div className='w-[12%] p-3'>Date</div>
//                                 <div className='w-[8%] p-3'>Kot No</div>
//                                 <div className='w-[8%] p-3'>Discount</div>
//                                 <div className='w-[10%] p-3'>Other Charges</div>
//                                 <div className='w-[10%] p-3'>Net Amount</div>
//                                 <div className='w-[10%] p-3'>Total</div>
//                                 <div className='w-[8%] p-3'>Type</div>
//                                 <div className='w-[10%] p-3'>Waiter</div>
//                                 <div className='w-[8%] p-3'>Status</div>
//                                 <div className='w-[8%] p-3'>Table</div>
//                             </div>

//                             <div className='w-full flex flex-col overflow-auto' style={{ maxHeight: 'calc(100vh - 200px)' }}>
//                                 {salesData.length === 0 && !loading && (
//                                     <div className="w-full p-8 text-center text-gray-500">
//                                         <p className="text-lg">No sales data found</p>
//                                         <p className="text-sm mt-2">
//                                             {dates.sdate || dates.edate
//                                                 ? "Try adjusting your date filters"
//                                                 : "No sales today yet"}
//                                         </p>
//                                     </div>
//                                 )}

//                                 {salesData.map((sale, index) => (
//                                     <div
//                                         className='w-full text-center font-[400] flex hover:bg-gray-50 border-b'
//                                         key={index}
//                                     >
//                                         <div onClick={() => handleShowBill(sale)} className='w-[8%] cursor-pointer p-3 text-left truncate'>{sale.BillNo}</div>
//                                         <div className='w-[12%] p-3 truncate'>{formatDate(sale.Date)}</div>
//                                         <div className='w-[8%] p-3 truncate'>{sale.KotNo || '-'}</div>
//                                         <div className='w-[8%] p-3 truncate'>{formatCurrency(sale.Discount)}</div>
//                                         <div className='w-[10%] p-3 truncate'>{formatCurrency(sale.OtherCharges)}</div>
//                                         <div className='w-[10%] p-3 truncate'>{formatCurrency(sale.NetAmount)}</div>
//                                         <div className='w-[10%] p-3 truncate font-semibold'>
//                                             {formatCurrency(sale.TotalAmount)}
//                                         </div>
//                                         <div className='w-[8%] p-3 truncate capitalize'>{sale.cardtype?.toLowerCase() || '-'}</div>
//                                         <div className='w-[10%] p-3 truncate'>{sale.Waiter || '-'}</div>
//                                         <div className='w-[8%] p-3 truncate'>
//                                             <span className={`px-2 py-1 rounded-full text-xs ${sale.Status === 'Paid' ? 'bg-green-100 text-green-800' :
//                                                 sale.Status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
//                                                     'bg-gray-100 text-gray-800'
//                                                 }`}>
//                                                 {sale.Status || '-'}
//                                             </span>
//                                         </div>
//                                         <div className='w-[8%] p-3 truncate'>{sale.TableNo || '-'}</div>
//                                     </div>
//                                 ))}

//                                 {loading && (
//                                     <div className="w-full p-8 text-center">
//                                         <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Load more controls */}
//                             {!loading && hasMore && salesData.length > 0 && (
//                                 <div className="w-full p-4 text-center sticky bottom-0 bg-white border-t">
//                                     <button
//                                         onClick={() => loadMoreData()}
//                                         className="bg-[#0008B4] text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors mr-2"
//                                         disabled={loading}
//                                     >
//                                         Load More
//                                     </button>
//                                     <button
//                                         onClick={() => loadMoreData(true)}
//                                         className="bg-gray-200 text-gray-800 px-6 py-2 rounded-md hover:bg-gray-300 transition-colors"
//                                         disabled={loading}
//                                     >
//                                         Load All
//                                     </button>
//                                 </div>
//                             )}

//                             {!hasMore && salesData.length > 0 && (
//                                 <div className="w-full p-4 text-center text-gray-500 bg-gray-50">
//                                     Showing {salesData.length} records
//                                 </div>
//                             )}

//                         </div>

//                     </div>

//                             <div className="fixed inset-0  bg-opacity-70 flex justify-center items-center z-50">
//                                 <div className="relative w-full max-w-7xl bg-white rounded-xl shadow-lg p-6">

//                                     {/* Close Button */}
//                                     <button
//                                         onClick={() => setShowOnebill(false)}
//                                         className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
//                                     >
//                                         ✕
//                                     </button>

//                                     {/* Title */}
//                                     <h2 className="text-lg font-semibold text-gray-800 mb-4">Bill Details</h2>

//                                     {/* Table */}
//                                     <div className="overflow-x-auto">
//                                         <table className="w-full border border-gray-200 rounded-lg">
//                                             <thead className="bg-gray-100">
//                                                 <tr>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Bill No</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Bank Name</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Card No</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Cess</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Credit Account</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Customer</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Date</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Discount</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">kOT No</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Net</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Net Amount</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Obill No</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Other Charges</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Time</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Total Amount</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Type</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Vbill No</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Waiter</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Address</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Balance</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Bill Status</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Card Type</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Cash Recieved</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">CGST</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Dine Type</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Area</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Table No</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">KOT Status</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Locality</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Mob No</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Name</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Narration</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Note</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Persons</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Print Status</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Service Tax</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Settilment Status</th>
//                                                     <th className="text-left py-2 px-3 border-b whitespace-nowrap w-auto">Sgst</th>

//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr className="hover:bg-gray-50">
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.BillNo}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.BankName}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.CardNumber}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Cess}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.CreditAccount}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Customer}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Date}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Discount}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.KOTNo}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Net}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.NetAmount}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.OBillNo}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.OtherCharges}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Time}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.TotalAmount}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Type}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.VBillNO}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.Waiter}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.address}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.balance}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.billstatus}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.cardtype}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.cashrecieved}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.cgst}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.dinetype}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.floor}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.tableno}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.kotstatus}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.locality}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.mobno}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.name}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.narration}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.note}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.persons}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.printstatus}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.serviceTAX}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.settilmentstatus}</td>
//                                                     <td className="py-2 px-3 border-b whitespace-nowrap w-auto">{oneBill?.sgst}</td>
//                                                 </tr>

//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default BillReport;

import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import { useReactToPrint } from 'react-to-print';
import "./css/BillerApp.css";
import 'bootstrap/dist/css/bootstrap.css';
import Editing1 from './images/MenuReg/Editing1.png';
import Redeye1 from './images/Inventory/visible.png';
import remove from './images/Inventory/delete.png';
import right from './images/right-arrow.png';
import SideNav from './SideNav';
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import io from 'socket.io-client';
import { DBContext } from './DBContext';
import Qsearch from "./images/Qsearch.png";
import { exportToCSV } from '../utils/exportUtils';

// ── CSV column definitions for BillReport ──
const BILL_COLS = [
    { key: 'BillNo', label: 'Bill No' },
    { key: 'Date', label: 'Date' },
    { key: 'Time', label: 'Time' },
    { key: 'dinetype', label: 'Type' },
    { key: 'TotalAmount', label: 'Gross (₹)' },
    { key: 'Discount', label: 'Discount (₹)' },
    { key: 'NetAmount', label: 'Net (₹)' },
    { key: 'cgst', label: 'CGST (₹)' },
    { key: 'sgst', label: 'SGST (₹)' },
    { key: 'cashrecieved', label: 'Cash (₹)' },
    { key: 'cardamount', label: 'Card (₹)' },
    { key: 'onlineAmount', label: 'Online (₹)' },
    { key: 'creditAmount', label: 'Credit (₹)' },
];

// ── Hidden print view for BillReport ──
const BillReportPrintView = React.forwardRef(({ salesData, dates }, ref) => {
    const totalNet = salesData.reduce((s, b) => s + parseFloat(b.NetAmount || 0), 0);
    const totalCash = salesData.reduce((s, b) => s + parseFloat(b.cashrecieved || 0), 0);
    const totalCard = salesData.reduce((s, b) => s + parseFloat(b.cardamount || 0), 0);
    const fmt = (v) => `₹${parseFloat(v || 0).toFixed(2)}`;
    return (
        <div ref={ref} style={{ padding: '20px', fontFamily: 'Arial, sans-serif', fontSize: '11px' }}>
            <h2 style={{ fontSize: '16px', fontWeight: '700', marginBottom: '4px' }}>Sales Report</h2>
            <p style={{ color: '#666', marginBottom: '12px' }}>
                {dates.sdate && dates.edate ? `${dates.sdate}  →  ${dates.edate}` : 'Today'}
            </p>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '14px', flexWrap: 'wrap' }}>
                {[['Bills', salesData.length], ['Net Revenue', fmt(totalNet)], ['Cash', fmt(totalCash)], ['Card', fmt(totalCard)]].map(([l, v]) => (
                    <div key={l} style={{ background: '#f5f5f5', borderRadius: '6px', padding: '6px 12px' }}>
                        <div style={{ fontSize: '9px', color: '#888', textTransform: 'uppercase' }}>{l}</div>
                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#0008B4' }}>{v}</div>
                    </div>
                ))}
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ background: '#0008B4', color: '#fff' }}>
                        {BILL_COLS.map(c => <th key={c.key} style={{ padding: '5px 8px', textAlign: 'left', fontSize: '10px' }}>{c.label}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {salesData.map((row, i) => (
                        <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                            {BILL_COLS.map(c => (
                                <td key={c.key} style={{ padding: '4px 8px', borderBottom: '1px solid #eee', fontSize: '10px' }}>
                                    {row[c.key] ?? ''}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
});

// ── Hidden print view for Single Bill Details ──
const SingleBillPrintView = React.forwardRef(({ bill }, ref) => {
    if (!bill) return null;
    const f = (v) => `₹${parseFloat(v || 0).toFixed(2)}`;
    return (
        <div ref={ref} style={{ padding: '30px', fontFamily: 'Arial, sans-serif', fontSize: '12px', color: '#333' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px', borderBottom: '2px solid #333', paddingBottom: '10px' }}>
                <h2 style={{ margin: '0 0 5px 0', fontSize: '18px', fontWeight: 'bold', textTransform: 'uppercase' }}>Transaction Receipt</h2>
                <p style={{ margin: 0, color: '#666' }}>Bill No: {bill.BillNo}</p>
                <p style={{ margin: '2px 0 0 0', color: '#666' }}>Date: {new Date(bill.Date).toLocaleDateString()}</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                <div>
                    <h3 style={{ borderBottom: '1px solid #ddd', paddingBottom: '4px', fontSize: '13px', fontWeight: 'bold', margin: '0 0 8px 0' }}>Bill Info</h3>
                    <p style={{ margin: '3px 0' }}><strong>Customer:</strong> {bill.Customer || 'Walk-in'}</p>
                    <p style={{ margin: '3px 0' }}><strong>Type:</strong> {bill.dinetype || '-'}</p>
                    <p style={{ margin: '3px 0' }}><strong>Waiter:</strong> {bill.Waiter || '-'}</p>
                    <p style={{ margin: '3px 0' }}><strong>KOT No:</strong> {bill.KotNo || '-'}</p>
                </div>
                <div>
                    <h3 style={{ borderBottom: '1px solid #ddd', paddingBottom: '4px', fontSize: '13px', fontWeight: 'bold', margin: '0 0 8px 0' }}>Payment Info</h3>
                    <p style={{ margin: '3px 0' }}><strong>Bank:</strong> {bill.BankName || '-'}</p>
                    <p style={{ margin: '3px 0' }}><strong>Card No:</strong> {bill.CardNumber || '-'}</p>
                    <p style={{ margin: '3px 0' }}><strong>Credit Account:</strong> {bill.CreditAccount || '-'}</p>
                    <p style={{ margin: '3px 0' }}><strong>Status:</strong> {bill.billstatus === 1 ? 'Settled' : 'Unsettled'}</p>
                </div>
            </div>

            <div style={{ marginTop: '30px', borderTop: '2px solid #333', paddingTop: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', fontSize: '13px' }}>
                    <span>Gross Amount:</span>
                    <span>{f(bill.TotalAmount)}</span>
                </div>
                {parseFloat(bill.Discount || 0) > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', fontSize: '13px', color: '#e53e3e' }}>
                        <span>Discount:</span>
                        <span>-{f(bill.Discount)}</span>
                    </div>
                )}
                {parseFloat(bill.Cess || 0) > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', fontSize: '13px' }}>
                        <span>Cess:</span>
                        <span>{f(bill.Cess)}</span>
                    </div>
                )}
                {parseFloat(bill.OtherCharges || 0) > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', fontSize: '13px' }}>
                        <span>Other Charges:</span>
                        <span>{f(bill.OtherCharges)}</span>
                    </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0 0 0', paddingTop: '10px', borderTop: '1px solid #333', fontSize: '16px', fontWeight: 'bold' }}>
                    <span>Net Amount:</span>
                    <span>{f(bill.NetAmount)}</span>
                </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '50px', borderTop: '1px solid #ddd', paddingTop: '10px', color: '#888', fontSize: '10px' }}>
                Thank you for your visit!
            </div>
        </div>
    );
});


function BillReport() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const { logginedDB } = useContext(DBContext);
    const navigate = useNavigate();
    const billPrintRef = useRef(null);
    const handleBillPrint = useReactToPrint({
        content: () => billPrintRef.current,
        documentTitle: 'Sales_Report',
    });

    const singleBillPrintRef = useRef(null);
    const handleSingleBillPrint = useReactToPrint({
        content: () => singleBillPrintRef.current,
        documentTitle: `Bill_Details`,
    });


    // Date filter state
    const getTodayStr = () => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };
    const [dates, setDates] = useState(() => {
        const today = getTodayStr();
        return { sdate: today, edate: today };
    });
    const [allMode, setAllMode] = useState(false);

    // Pagination state
    const [salesData, setSalesData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [offset, setOffset] = useState(0);
    const [initialLoadComplete, setInitialLoadComplete] = useState(false);
    const limit = 50;

    // User management states
    const [userTypes, setUserTypes] = useState([]);
    const [uType, setUType] = useState(null);
    const [userList, setUserList] = useState([]);
    const [isActive, setIsActive] = useState({});
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [sideNav, setSideNav] = useState(false);
    const [falseState, setFalseState] = useState(null);
    const [viewUserDetails, setViewUserDetails] = useState(null);
    const [isExiting, setIsExiting] = useState(false);
    const [showONebill, setShowOnebill] = useState(false);
    const [oneBill, setOneBill] = useState(null);
    const [billDetails, setBillDetails] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);


    const handleSideNav = (state) => {
        setSideNav(state);
    };

    // Sorting state and logic
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedSalesData = useMemo(() => {
        if (!sortConfig.key) return salesData;
        return [...salesData].sort((a, b) => {
            let valA = a[sortConfig.key];
            let valB = b[sortConfig.key];

            // Date sorting
            if (sortConfig.key === 'Date') {
                const dateA = new Date(valA);
                const dateB = new Date(valB);
                return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
            }

            // Numeric currency sorting
            if (['Discount', 'NetAmount', 'TotalAmount'].includes(sortConfig.key)) {
                const numA = parseFloat(valA || 0);
                const numB = parseFloat(valB || 0);
                return sortConfig.direction === 'asc' ? numA - numB : numB - numA;
            }

            // Numeric ID/Status sorting
            if (['BillNo', 'KotNo', 'billstatus'].includes(sortConfig.key)) {
                const numA = parseInt(valA || 0, 10);
                const numB = parseInt(valB || 0, 10);
                const aValid = !isNaN(numA);
                const bValid = !isNaN(numB);
                if (aValid && bValid) {
                    return sortConfig.direction === 'asc' ? numA - numB : numB - numA;
                }
                if (aValid) return sortConfig.direction === 'asc' ? -1 : 1;
                if (bValid) return sortConfig.direction === 'asc' ? 1 : -1;
            }

            // Fallback to string sorting (Type, Waiter, etc.)
            const strA = String(valA || '').toLowerCase();
            const strB = String(valB || '').toLowerCase();
            if (strA < strB) return sortConfig.direction === 'asc' ? -1 : 1;
            if (strA > strB) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });
    })

    console.log(sortedSalesData, 'sortedSalesData');

    const renderSortHeader = (label, key, widthClass, alignClass = 'text-left') => {
        const isSorted = sortConfig.key === key;
        const alignJustify = alignClass === 'text-right' ? 'justify-end' : alignClass === 'text-center' ? 'justify-center' : 'justify-start';

        return (
            <div
                onClick={() => handleSort(key)}
                className={`${widthClass} p-3 ${alignClass} text-xs font-semibold text-text-secondary-light dark:text-text-secondary-dark uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/50 transition-colors flex items-center ${alignJustify} gap-1 select-none`}
            >
                <span>{label}</span>
                <span className="text-[9px] text-[#aaa] font-bold">
                    {isSorted ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '⇅'}
                </span>
            </div>
        );
    };



    // Load more data
    const loadMoreData = useCallback(async (reset = false, selectedUserType = undefined) => {
        if (loading) return;
        setLoading(true);
        try {
            const currentOffset = reset ? 0 : offset;
            const queryUserType = selectedUserType !== undefined ? selectedUserType : uType?.userType;
            const apiParams = {
                limit,
                offset: currentOffset,
                userType: queryUserType || undefined,
            };
            if (allMode) {
                apiParams.all = true;
            } else {
                apiParams.sdate = dates.sdate || undefined;
                apiParams.edate = dates.edate || undefined;
            }

            const response = await axios.get(
                `${apiBaseUrl}/getSalesDetailsAlls/${logginedDB}`,
                { params: apiParams }
            );

            if (response.status === 200) {
                const newData = response.data.data || [];
                if (reset) {
                    setSalesData(newData);
                } else {
                    setSalesData(prev => [...prev, ...newData]);
                }
                setHasMore(response.data.hasMore || false);
                setOffset(currentOffset + newData.length);
                if (reset) setInitialLoadComplete(true);
            }
        } catch (error) {
            console.error("Error loading sales data:", error);
            toast.error("Failed to load sales data");
        } finally {
            setLoading(false);
        }
    }, [loading, offset, limit, logginedDB, uType, dates, allMode]);

    // Initial load and reset handler
    useEffect(() => {
        if (logginedDB) {
            loadMoreData(true);
        }
    }, [logginedDB]);

    useEffect(() => {
        if (logginedDB && !initialLoadComplete) {
            loadMoreData();
        }
    }, [logginedDB, initialLoadComplete, loadMoreData]);

    const handleList = async (type) => {
        setUType(type);
        loadMoreData(true, type.userType);
        setCheckedItems(userList.map(() => false));
        setIsCheckedAll(false);
    };

    // Infinite scroll handler
    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop <
                document.documentElement.offsetHeight - 100 ||
                loading ||
                !hasMore
            ) {
                return;
            }
            loadMoreData();
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, hasMore, loadMoreData]);

    // Handle date range search — always uses getSalesDetailsAlls with sdate/edate params
    const handleSearch = async () => {
        if (dates.sdate && dates.edate && dates.sdate > dates.edate) {
            toast.error("End date must be after start date");
            return;
        }

        const datesAreEmpty = !dates.sdate && !dates.edate;
        if (datesAreEmpty) {
            setAllMode(true);
        } else {
            setAllMode(false);
        }

        setLoading(true);
        try {
            const queryParams = {
                userType: uType?.userType || undefined,
            };

            if (datesAreEmpty) {
                queryParams.all = true;
            } else {
                queryParams.sdate = dates.sdate || undefined;
                queryParams.edate = dates.edate || undefined;
            }

            const response = await axios.get(
                `${apiBaseUrl}/getSalesDetailsAlls/${logginedDB}`,
                { params: queryParams }
            );

            if (response.status === 200) {
                setSalesData(response.data.data || []);
                setHasMore(false); // filtered result — no infinite scroll
                setOffset(0);
            }
        } catch (error) {
            console.error("Error fetching sales data:", error);
            toast.error("Failed to fetch sales data");
        } finally {
            setLoading(false);
        }
    };

    // Reset to today's data
    const handleReset = () => {
        const today = getTodayStr();
        setDates({ sdate: today, edate: today });
        setSalesData([]);
        setOffset(0);
        setHasMore(true);
        setInitialLoadComplete(false);
    };

    // Load all data
    const handleLoadAll = async () => {
        setDates({ sdate: "", edate: "" });
        setAllMode(true);
        setLoading(true);
        try {
            const response = await axios.get(
                `${apiBaseUrl}/getSalesDetailsAlls/${logginedDB}`,
                {
                    params: {
                        all: true,
                        userType: uType?.userType || undefined
                    }
                }
            );
            if (response.status === 200) {
                setSalesData(response.data.data);
                setHasMore(false);
                setOffset(0);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to load all records");
        } finally {
            setLoading(false);
        }
    };

    // Format currency
    const formatCurrency = (amount) => {
        return parseFloat(amount || 0).toFixed(2);
    };

    // Format date
    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const formatDisplayDate = (dateString) => {
        if (!dateString) return '';
        const cleanDateStr = dateString.includes('T') ? dateString.split('T')[0] : dateString;
        const parts = cleanDateStr.split('-');
        let year, month, day;
        if (parts.length === 3) {
            year = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1;
            day = parseInt(parts[2], 10);
        } else {
            const d = new Date(dateString);
            if (isNaN(d.getTime())) return dateString;
            year = d.getFullYear();
            month = d.getMonth();
            day = d.getDate();
        }

        const inputDate = new Date(year, month, day);
        const today = new Date();
        const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const yesterdayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);

        if (inputDate.getTime() === todayDate.getTime()) {
            return "Today";
        } else if (inputDate.getTime() === yesterdayDate.getTime()) {
            return "Yesterday";
        } else {
            const dd = String(day).padStart(2, '0');
            const mm = String(month + 1).padStart(2, '0');
            return `${dd}/${mm}/${year}`;
        }
    };

    // Handle showing bill details modal
    const handleShowBill = async (data) => {
        setOneBill(data);
        setShowOnebill(true);
        setLoadingDetails(true);
        setBillDetails(null);
        try {
            const response = await axios.get(`${apiBaseUrl}/reports/bill-details/${logginedDB}/${data.BillNo}`);
            if (response.status === 200 && response.data.success) {
                setBillDetails(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching bill details:", error);
            toast.error("Failed to load bill items");
        } finally {
            setLoadingDetails(false);
        }
    };

    // Socket and user types (as in original)
    const socketRef = useRef(null);

    const handleGetUserTypes = async () => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getUserTypes/${logginedDB}`);
            if (response.status === 200) {
                setUserTypes(response.data);
            }
        } catch (error) {
            console.error("Error fetching user types:", error);
        }
    };

    useEffect(() => {
        if (!logginedDB) return;
        handleGetUserTypes();

        socketRef.current = io(apiBaseUrl, {
            transports: ["websocket"],
        });

        const geteHandlerUserTypes = () => handleGetUserTypes();

        socketRef.current.on("connect", () => {
            console.log("Connected to server");
        });

        socketRef.current.on("disconnect", () => {
            console.log("Disconnected from server");
        });

        socketRef.current.on("connect_error", (error) => {
            console.error("Connection error:", error);
        });

        socketRef.current.on("updateUser", geteHandlerUserTypes);

        return () => {
            if (socketRef.current) {
                socketRef.current.off("updateUser", geteHandlerUserTypes);
                socketRef.current.disconnect();
            }
        };
    }, [apiBaseUrl, logginedDB]);

    return (
        <div className='TableRegMainDiv bg-background-light dark:bg-background-dark min-h-screen'>
            <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
            <ToastContainer position="top-right" autoClose={3000} />

            <div className='w-full flex gap-3 h-full overflow-hidden'>
                <div className='w-max h-full z-[9999]'>
                    <SideNav focus={'Report'} state={sideNav} falseState={(state) => setFalseState(state)} />
                </div>

                <div className='w-full h-full bg-[#f5f5f5] flex flex-col p-3 pb-3 pt-0 gap-3 overflow-hidden'>
                    <div className="pr-3 h-max w-full bg-white border-b border-[#E8E8E8]">
                        <TopRootDiv image={'Report'} root={['Report']} section={"Sales Report"} />
                    </div>

                    <div className='w-full h-full flex flex-col gap-3 relative overflow-hidden'>



                        {/* ── Compact toolbar row ── */}
                        <div className='bg-white rounded-xl shadow-sm border border-[#E8E8E8] px-4 py-3 flex items-center gap-3 flex-wrap'>

                            {/* Title block */}
                            <div className='flex flex-col min-w-max'>
                                <span className='text-[.92rem] font-bold text-[#464255] leading-tight'>Sales Overview</span>
                                <span className='text-[.7rem] text-[#aaa]'>Daily transactions report</span>
                            </div>

                            <div className='w-px h-8 bg-[#E8E8E8] hidden sm:block' />

                            {/* Date range inputs */}
                            <div className='flex items-center gap-1 border border-[#E0E0E0] rounded-lg px-2 py-1.5 bg-white'>
                                <span className='text-[.6rem] font-bold text-[#bbb] uppercase tracking-wide'>From</span>
                                <input
                                    type="date"
                                    value={dates.sdate}
                                    onChange={(e) => {
                                        setDates({ ...dates, sdate: e.target.value });
                                        setAllMode(false);
                                    }}
                                    className="bg-transparent border-none text-[.82rem] text-[#464255] focus:ring-0 py-0 cursor-pointer outline-none"
                                />
                                <span className='text-[.6rem] font-bold text-[#bbb] uppercase tracking-wide mx-1'>To</span>
                                <input
                                    type="date"
                                    value={dates.edate}
                                    onChange={(e) => {
                                        setDates({ ...dates, edate: e.target.value });
                                        setAllMode(false);
                                    }}
                                    className="bg-transparent border-none text-[.82rem] text-[#464255] focus:ring-0 py-0 cursor-pointer outline-none"
                                />
                            </div>

                            {/* Search */}
                            <button
                                onClick={handleSearch}
                                className="px-4 py-1.5 rounded-lg bg-[#0008B4] hover:bg-[#0006a0] text-white text-[.82rem] font-semibold transition-colors shadow-sm whitespace-nowrap"
                            >
                                Search
                            </button>

                            {/* All Records */}
                            <button
                                onClick={handleLoadAll}
                                className="px-4 py-1.5 rounded-lg border border-[#E0E0E0] bg-white hover:bg-[#f5f5f5] text-[.82rem] font-medium text-[#464255] transition-colors whitespace-nowrap"
                            >
                                All Records
                            </button>

                            {/* Spacer — pushes export to right */}
                            <div className='flex-1' />

                            {/* Export CSV */}
                            <button
                                onClick={() => exportToCSV(`Sales_Report_${dates.sdate || 'all'}`, BILL_COLS, salesData)}
                                disabled={salesData.length === 0}
                                className="px-4 py-1.5 rounded-lg border border-[#E0E0E0] bg-white hover:bg-[#f5f5f5] text-[.82rem] font-medium text-[#464255] transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                            >
                                Export CSV
                            </button>

                            {/* Print / PDF */}
                            <button
                                onClick={handleBillPrint}
                                disabled={salesData.length === 0}
                                className="px-4 py-1.5 rounded-lg border border-[#E0E0E0] bg-white hover:bg-[#f5f5f5] text-[.82rem] font-medium text-[#464255] transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                            >
                                Print / PDF
                            </button>
                        </div>

                        {/* ── Combined Summary & User Type row ── */}
                        {(() => {
                            const s = salesData.reduce((acc, b) => {
                                acc.bills++;
                                acc.gross += parseFloat(b.TotalAmount || 0);
                                acc.disc += parseFloat(b.Discount || 0);
                                acc.net += parseFloat(b.NetAmount || 0);
                                acc.cgst += parseFloat(b.cgst || 0);
                                acc.sgst += parseFloat(b.sgst || 0);
                                acc.cash += parseFloat(b.cashrecieved || 0);
                                acc.card += parseFloat(b.cardamount || 0);
                                acc.online += parseFloat(b.onlineAmount || 0);
                                acc.credit += parseFloat(b.creditAmount || 0);
                                return acc;
                            }, { bills: 0, gross: 0, disc: 0, net: 0, cgst: 0, sgst: 0, cash: 0, card: 0, online: 0, credit: 0 });

                            const f = (v) => `₹${parseFloat(v || 0).toFixed(2)}`;
                            const gst = s.cgst + s.sgst;

                            const cell = (label, value, hi = false) => (
                                <div key={label} className={`flex flex-col items-center px-3 py-1 ${hi ? 'bg-[#0008B4]/10 rounded-lg px-3' : ''}`}>
                                    <span className='text-[.62rem] font-bold text-[#aaa] uppercase tracking-wider whitespace-nowrap'>{label}</span>
                                    <span className={`text-[.82rem] font-bold whitespace-nowrap ${hi ? 'text-[#0008B4]' : 'text-[#464255]'}`}>{value}</span>
                                </div>
                            );

                            return (
                                <div className='bg-white rounded-xl border border-[#E8E8E8] shadow-sm p-3 flex items-center justify-between gap-4 flex-wrap w-full'>
                                    {/* Metrics side */}
                                    <div className='flex items-center gap-0 flex-wrap flex-shrink flex-grow'>
                                        {/* Date / range pill */}
                                        <div className='flex items-center pr-3 border-r border-[#E8E8E8] flex-shrink-0'>
                                            <span className='text-[.72rem] font-bold text-[#464255] bg-[#f5f5f5] px-3 py-1.5 rounded-full whitespace-nowrap'>
                                                {(() => {
                                                    if (allMode) {
                                                        return "All Records";
                                                    }
                                                    if (dates.sdate && dates.edate) {
                                                        if (dates.sdate === dates.edate) {
                                                            return formatDisplayDate(dates.sdate);
                                                        }
                                                        return `${formatDisplayDate(dates.sdate)} → ${formatDisplayDate(dates.edate)}`;
                                                    }
                                                    return 'All';
                                                })()}
                                            </span>
                                        </div>
                                        {/* Metrics lists */}
                                        <div className='flex items-center divide-x divide-[#E8E8E8] pl-2 flex-wrap'>
                                            {cell('Bills', s.bills, false)}
                                            {cell('Gross', f(s.gross), false)}
                                            {s.disc > 0 && cell('Discount', f(s.disc), false)}
                                            {cell('Net', f(s.net), true)}
                                            {gst > 0 && cell('GST', f(gst), false)}
                                            {s.cash > 0 && cell('Cash', f(s.cash), false)}
                                            {s.card > 0 && cell('Card', f(s.card), false)}
                                            {s.online > 0 && cell('Online', f(s.online), false)}
                                            {s.credit > 0 && cell('Credit', f(s.credit), false)}
                                        </div>
                                    </div>

                                    {/* User types side */}
                                    <div className='flex items-center gap-2 bg-white px-2 py-1.5 rounded-lg border border-[#E0E0E0] flex-shrink-0 ml-auto'>
                                        <span className='text-[.7rem] font-bold text-[#aaa] uppercase tracking-wide'>Filter By User</span>
                                        <select
                                            value={uType?.userType || ''}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (!val) {
                                                    setUType(null);
                                                    loadMoreData(true, null);
                                                } else {
                                                    const selectedType = userTypes.find(t => t.userType === val);
                                                    if (selectedType) {
                                                        handleList(selectedType);
                                                    }
                                                }
                                            }}
                                            className='font-nunito text-[.82rem] font-bold border-none outline-none focus:ring-0 bg-transparent text-[#464255] cursor-pointer py-0'
                                        >
                                            <option value="">All Users</option>
                                            {userTypes.map((type, index) => (
                                                <option key={index} value={type.userType}>
                                                    {type.userType}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            );
                        })()}

                        {/* Sales data table */}
                        <div className='w-full font-nunito flex flex-col bg-white overflow-y-auto rounded-xl shadow-sm border border-[#E8E8E8]' style={{ maxHeight: 'calc(100vh - 280px)' }}>
                            <div className='w-full text-center font-[600] flex bg-white border-b border-[#E8E8E8] sticky top-0 z-10'>

                                {renderSortHeader('Bill No', 'BillNo', 'w-[10%]', 'text-center')}
                                {renderSortHeader('Date', 'Date', 'w-[12%]', 'text-center')}
                                {renderSortHeader('Time', 'Time', 'w-[12%]', 'text-center')}
                                {renderSortHeader('KOT', 'KotNo', 'w-[14%]', 'text-center')}
                                {renderSortHeader('Table', 'Table', 'w-[10%]', 'text-center')}
                                {renderSortHeader('Total', 'TotalAmount', 'w-[10%]', 'text-center')}
                                {renderSortHeader('Type', 'dinetype', 'w-[12%]', 'text-center')}
                                {/* {renderSortHeader('Waiter', 'Waiter', 'w-[10%]', 'text-center')} */}
                                {renderSortHeader('Status', 'billstatus', 'w-[12%]', 'text-center')}
                                <div className='w-[8%] p-3 text-xs font-semibold text-text-secondary-light dark:text-text-secondary-dark uppercase tracking-wider text-center select-none'>Action</div>
                            </div>

                            <div className='w-full flex flex-col'>
                                {salesData.length === 0 && !loading && (
                                    <div className="w-full p-8 text-center text-text-secondary-light dark:text-text-secondary-dark">
                                        <p className="text-lg">No sales data found</p>
                                        <p className="text-sm mt-2">
                                            {dates.sdate || dates.edate
                                                ? "Try adjusting your date filters"
                                                : "No sales today yet"}
                                        </p>
                                    </div>
                                )}

                                {sortedSalesData.map((sale, index) => (
                                    <div
                                        className='w-full text-center font-[400] flex hover:bg-gray-50 border-b border-[#E8E8E8] transition-colors bg-white'
                                        key={index}
                                    >
                                        <div title={sale.BillNo} className='w-[10%] p-3 text-center text-sm font-medium text-text-primary-light dark:text-text-primary-dark truncate cursor-default'>{sale.BillNo}</div>
                                        <div title={formatDisplayDate(sale.Date)} className='w-[12%] p-3 text-center text-sm text-text-secondary-light dark:text-text-secondary-dark truncate cursor-default'>{formatDisplayDate(sale.Date)}</div>
                                        <div title={sale.Time} className='w-[12%] p-3 text-center text-sm text-text-secondary-light dark:text-text-secondary-dark truncate cursor-default'>{sale.Time}</div>
                                        <div title={sale.KOTNo || '-'} className='w-[14%] p-3 text-center text-sm text-text-secondary-light dark:text-text-secondary-dark truncate cursor-default'>{sale.KOTNo || '-'}</div>
                                        <div title={sale.tableno || '-'} className='w-[10%] p-3 text-center text-sm text-text-secondary-light dark:text-text-secondary-dark truncate'>{sale.tableno || '-'}</div>
                                        {/* <div title={formatCurrency(sale.NetAmount)} className='w-[12%] p-3 text-center text-sm font-medium text-text-primary-light dark:text-text-primary-dark truncate cursor-default'>{formatCurrency(sale.NetAmount)}</div> */}
                                        <div title={formatCurrency(sale.TotalAmount)} className='w-[10%] p-3 text-center text-sm font-bold text-text-primary-light dark:text-text-primary-dark truncate cursor-default'>{formatCurrency(sale.TotalAmount)}</div>
                                        <div title={sale.Type || '-'} className='w-[12%] p-3 text-center flex items-center justify-center'>
                                            <span className={`px-2 py-1 rounded-full text-xs font-medium 
                                                ${(sale.Type?.toLowerCase() === 'dine in' || sale.Type?.toLowerCase() === 'dine-in') ? 'bg-blue-100 text-blue-700' :
                                                    sale.Type?.toLowerCase() === 'take away' ? 'bg-purple-100 text-purple-700' :
                                                        sale.Type?.toLowerCase() === 'delivery' ? 'bg-orange-100 text-orange-700' :
                                                            'bg-gray-100 text-gray-700'
                                                }`}>
                                                {sale.Type || '-'}
                                            </span>
                                        </div>
                                        {/* <div title={sale.Waiter || '-'} className='w-[10%] p-3 text-center text-sm text-text-secondary-light dark:text-text-secondary-dark truncate'>{sale.Waiter || '-'}</div> */}
                                        <div className='w-[12%] p-3 flex items-center text-sm justify-center'>
                                            {/* <div className={`inline-flex items-center justify-center w-6 h-6 rounded-full 
                                                ${sale.billstatus === 1 ? 'bg-green-100' : 'bg-red-100'}`}>
                                                <div className={`w-2 h-2 rounded-full 
                                                    ${sale.billstatus === 1 ? 'bg-green-500' : 'bg-red-500'}`}>
                                                </div>
                                            </div> */}
                                            <span className={`${sale.billstatus == 1 ? 'text-green-500' : 'text-red-500'}`}>{sale.billstatus == 1 ? 'Completed' : 'Pending'}</span>
                                        </div>
                                        <div className='w-[8%] p-3 flex items-center justify-center'>
                                            <button
                                                onClick={(e) => { e.stopPropagation(); handleShowBill(sale); }}
                                                className="text-[#888] hover:text-[#0008B4] transition-colors"
                                                title="View bill"
                                            >
                                                {/* Eye icon — inline SVG, no font dependency */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                ))}

                                {loading && (
                                    <div className="w-full p-8 text-center bg-white">
                                        <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div className='bg-white border-t border-[#E8E8E8] px-4 py-3 flex items-center justify-between sticky bottom-0 mt-auto'>
                                <p className='text-sm text-text-secondary-light dark:text-text-secondary-dark'>
                                    Showing <span className='font-medium text-text-primary-light dark:text-text-primary-dark'>{salesData.length}</span> records
                                </p>
                                {!loading && hasMore && salesData.length > 0 && (
                                    <button
                                        onClick={() => loadMoreData()}
                                        className='px-4 py-1.5 text-sm font-medium rounded-lg border border-border-light hover:bg-[#f5f5f5] text-text-secondary-light transition-colors'
                                    >
                                        Load More
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Bill Details Modal */}
                        {showONebill && oneBill && (
                            <div className="absolute inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowOnebill(false)}>
                                <div className="bg-[#f8f9fa] dark:bg-surface-dark rounded-2xl shadow-2xl w-full max-w-5xl border border-[#E8E8E8] flex flex-col max-h-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
                                    {/* Header */}
                                    <div className="px-6 py-4 bg-gradient-to-r from-[#0008B4] to-[#434bdf] flex flex-col gap-3 shrink-0">
                                        <div className="flex items-center justify-between">
                                            <h3 className="text-xl font-bold text-white tracking-wide">Bill Details</h3>
                                            <button
                                                onClick={() => setShowOnebill(false)}
                                                className="text-white/80 hover:text-white transition-colors p-1 rounded-full hover:bg-white/20"
                                            >
                                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                                            </button>
                                        </div>
                                        <div className="flex flex-wrap items-center gap-6 text-white text-sm">
                                            <div className="flex flex-col"><span className="text-blue-200 text-xs uppercase tracking-wider">Bill No</span><span className="font-semibold text-lg">{oneBill.BillNo}</span></div>
                                            <div className="flex flex-col"><span className="text-blue-200 text-xs uppercase tracking-wider">Date</span><span className="font-semibold text-base">{formatDate(oneBill.Date)}</span></div>
                                            <div className="flex flex-col"><span className="text-blue-200 text-xs uppercase tracking-wider">Time</span><span className="font-semibold text-base">{oneBill.Time || '-'}</span></div>
                                            <div className="flex flex-col"><span className="text-blue-200 text-xs uppercase tracking-wider">Table</span><span className="font-semibold text-base">{oneBill.tableno || '-'}</span></div>
                                            <div className="flex flex-col"><span className="text-blue-200 text-xs uppercase tracking-wider">Status</span><span className="font-semibold px-2 py-0.5 bg-green-500/20 text-green-100 rounded-md border border-green-400/30">{oneBill.billstatus == 1 ? 'Completed' : 'Pending'}</span></div>
                                        </div>
                                    </div>
                                    
                                    {/* Content */}
                                    <div className="p-6 overflow-y-auto flex-1 bg-[#f8f9fa] custom-scrollbar">
                                        {loadingDetails ? (
                                            <div className="w-full h-64 flex flex-col items-center justify-center space-y-4">
                                                <div className="w-12 h-12 border-4 border-[#0008B4] border-t-transparent rounded-full animate-spin"></div>
                                                <p className="text-[#464255] font-medium animate-pulse">Loading bill details...</p>
                                            </div>
                                        ) : billDetails ? (
                                            <div className="flex flex-col gap-6">
                                                {/* Details Rows */}
                                                <div className="flex flex-col gap-4">
                                                    {/* Row 1: Area, Waiter, Type */}
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                        <div className="bg-white p-4 rounded-xl shadow-sm border border-[#E8E8E8] flex items-center gap-4 hover:shadow-md transition-shadow">
                                                            <div className="w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center text-orange-600">
                                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-xs text-[#aaa] font-bold uppercase tracking-wider">Area</p>
                                                                <p className="text-[#464255] font-bold text-sm mt-1">{billDetails.Area || '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="bg-white p-4 rounded-xl shadow-sm border border-[#E8E8E8] flex items-center gap-4 hover:shadow-md transition-shadow">
                                                            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-600">
                                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-xs text-[#aaa] font-bold uppercase tracking-wider">Waiter</p>
                                                                <p className="text-[#464255] font-bold text-sm mt-1">{billDetails.waiter || '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="bg-white p-4 rounded-xl shadow-sm border border-[#E8E8E8] flex items-center gap-4 hover:shadow-md transition-shadow">
                                                            <div className="w-10 h-10 rounded-full bg-purple-50 flex items-center justify-center text-purple-600">
                                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-xs text-[#aaa] font-bold uppercase tracking-wider">Type</p>
                                                                <p className="text-[#464255] font-bold text-sm mt-1">{billDetails.type}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Row 2: Customer Details */}
                                                    <div className="bg-white p-4 rounded-xl shadow-sm border border-[#E8E8E8] flex flex-col gap-2 hover:shadow-md transition-shadow">
                                                        <p className="text-xs text-[#aaa] font-bold uppercase tracking-wider border-b border-[#f0f0f0] pb-2 mb-1">Customer Details</p>
                                                        <div className="flex items-center gap-8">
                                                            <div className="flex flex-col">
                                                                <span className="text-xs text-[#888]">Name</span>
                                                                <span className="text-[#464255] font-bold text-sm">{billDetails.customerName || 'Walk-in'}</span>
                                                            </div>
                                                            <div className="flex flex-col">
                                                                <span className="text-xs text-[#888]">Phone Number</span>
                                                                <span className="text-[#464255] font-bold text-sm">{billDetails.customerNumber || 'N/A'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* KOT Items List */}
                                                <div className="bg-white rounded-xl shadow-sm border border-[#E8E8E8] overflow-hidden">
                                                    <div className="bg-[#f4f6fa] px-5 py-3 border-b border-[#E8E8E8]">
                                                        <h4 className="font-bold text-[#464255] text-sm">Order Items</h4>
                                                    </div>
                                                    <div className="p-0">
                                                        {billDetails.kots && billDetails.kots.length > 0 ? (
                                                            <div className="flex flex-col">
                                                                {billDetails.kots.map((kot, idx) => (
                                                                    <div key={idx} className={`${idx !== billDetails.kots.length - 1 ? 'border-b border-[#E8E8E8]' : ''}`}>
                                                                        <div className="bg-[#E0E0E0] px-5 py-2 flex items-center justify-between border-b border-[#f0f0f0]">
                                                                            <span className="text-xs font-bold text-[#000] uppercase tracking-wide flex items-center gap-2">
                                                                                <svg className="w-4 h-4 text-[#000]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path></svg>
                                                                                KOT: {kot.id}
                                                                            </span>
                                                                            <span className="text-xs font-medium text-[#000]">{kot.time}</span>
                                                                        </div>
                                                                        <table className="w-full text-left">
                                                                            {/* <thead className="bg-white text-[10px] uppercase text-[#888]">
                                                                                <tr>
                                                                                    <th className="px-5 py-2 font-medium">Item Name</th>
                                                                                    <th className="px-5 py-2 font-medium text-center">Qty</th>
                                                                                    <th className="px-5 py-2 font-medium text-right">Rate</th>
                                                                                    <th className="px-5 py-2 font-medium text-right">Amount</th>
                                                                                </tr>
                                                                            </thead> */}
                                                                            <tbody className="text-sm">
                                                                                {kot.items.map((item, itemIdx) => (
                                                                                    <tr key={itemIdx} className="hover:bg-blue-50/50 transition-colors">
                                                                                        {/* <td className="px-5 py-3 font-medium text-[#464255] border-t border-[#f5f5f5]">{item.name} x {item.qty}</td> */}
                                                                                        <td className="px-5 py-3 text-left border-t border-[#f5f5f5]">
                                                                                            <span className="uppercase text-gray-700 px-2 py-1 rounded text-xs font-bold">{item.name} x</span>
                                                                                            <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs font-bold">{item.qty}</span>
                                                                                        </td>
                                                                                        <td className="px-5 py-3 text-right text-[#888] border-t border-[#f5f5f5]">₹{formatCurrency(item.price)}</td>
                                                                                        <td className="px-5 py-3 text-right font-bold text-[#464255] border-t border-[#f5f5f5]">₹{formatCurrency(item.total)}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <div className="p-8 text-center text-[#aaa]">No items found for this bill.</div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Summary Section */}
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                    {/* Payment Details */}
                                                    <div className="bg-white rounded-xl shadow-sm border border-[#E8E8E8] p-5 h-max">
                                                        <h4 className="font-bold text-[#464255] text-sm mb-4 flex items-center gap-2">
                                                            <svg className="w-5 h-5 text-[#0008B4]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path></svg>
                                                            Payment Method
                                                        </h4>
                                                        <div className="space-y-3">
                                                            {billDetails.paymentMethod && Object.keys(billDetails.paymentMethod).length > 0 ? (
                                                                Object.entries(billDetails.paymentMethod).map(([method, amount], idx) => (
                                                                    <div key={idx} className="flex justify-between items-center p-3 rounded-lg border border-[#f0f0f0] bg-[#fafafa]">
                                                                        <span className="text-sm font-medium text-[#666] capitalize">{method}</span>
                                                                        <span className="text-sm font-bold text-[#464255]">₹{formatCurrency(amount)}</span>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div className="text-sm text-[#aaa]">Payment details unavailable</div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Financial Summary */}
                                                    <div className="bg-gradient-to-br from-[#f8fbff] to-[#f0f4ff] rounded-xl shadow-sm border border-blue-100 p-5">
                                                        <h4 className="font-bold text-[#0008B4] text-sm mb-4">Financial Summary</h4>
                                                        <div className="space-y-3">
                                                            <div className="flex justify-between items-center text-sm text-[#666]">
                                                                <span>Subtotal</span>
                                                                <span className="font-medium text-[#464255]">₹{formatCurrency(billDetails.financials?.subtotal)}</span>
                                                            </div>
                                                            <div className="flex justify-between items-center text-sm text-[#666]">
                                                                <span>Tax Amount</span>
                                                                <span className="font-medium text-[#464255]">₹{formatCurrency(billDetails.financials?.tax)}</span>
                                                            </div>
                                                            {parseFloat(billDetails.financials?.discount || 0) > 0 && (
                                                                <div className="flex justify-between items-center text-sm text-red-500">
                                                                    <span>Discount</span>
                                                                    <span className="font-medium">-₹{formatCurrency(billDetails.financials?.discount)}</span>
                                                                </div>
                                                            )}
                                                            <div className="pt-3 mt-3 border-t border-blue-200">
                                                                <div className="flex justify-between items-center">
                                                                    <span className="text-base font-bold text-[#0008B4]">Total Amount</span>
                                                                    <span className="text-xl font-black text-[#0008B4]">₹{formatCurrency(billDetails.financials?.total)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="w-full h-64 flex flex-col items-center justify-center">
                                                <p className="text-[#aaa] font-medium">Failed to load bill details.</p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Footer */}
                                    <div className="px-6 py-4 border-t border-[#E8E8E8] bg-white flex justify-end gap-3 shrink-0">
                                        <button
                                            onClick={() => setShowOnebill(false)}
                                            className="px-5 py-2 rounded-lg border border-[#E0E0E0] bg-white hover:bg-[#f5f5f5] text-sm font-medium text-[#464255] transition-colors"
                                        >
                                            Close
                                        </button>
                                        <button
                                            onClick={handleSingleBillPrint}
                                            className="px-5 py-2 rounded-lg bg-[#0008B4] hover:bg-[#0006a0] text-white text-sm font-medium transition-colors shadow-md hover:shadow-lg flex items-center gap-2"
                                        >
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path></svg>
                                            Print Receipt
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className='hidden'>
                <BillReportPrintView ref={billPrintRef} salesData={salesData} dates={dates} />
                <SingleBillPrintView ref={singleBillPrintRef} bill={oneBill} />
            </div>
        </div>
    );
}

export default BillReport;
